import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/blogPostCategories';

/* ---------- Get ---------- */

// Get all categories
export async function getAllCategories() {
  return await sendRequest(BASE_URL, 'GET');
}

// Get all categories with post counts
export async function getAllCategoriesWithPostCounts() {
  return await sendRequest(`${BASE_URL}/with-counts`, 'GET');
}

// Get category with posts by slug
export async function getCategoryBySlugWithBlogPosts(
  slug,
  { filter = {} } = {},
) {
  const query = new URLSearchParams({
    ...filter,
  }).toString();

  return await sendRequest(`${BASE_URL}/${slug}?${query}`, 'GET');
}

// Get category with posts for blog page by slug
export const getCategoryBySlugWithBlogPagePosts = (slug) =>
  getCategoryBySlugWithBlogPosts(slug, {
    filter: { showOnBlog: true },
  });

/* ---------- Create ---------- */

// Create a Blog post category
export async function createCategory(data) {
  return await sendRequest(BASE_URL, 'POST', data);
}

/* ---------- Update ---------- */

// Edit a Blog post category
export async function updateCategory(id, data) {
  return await sendRequest(`${BASE_URL}/${id}`, 'PUT', data);
}

/* ---------- Delete ---------- */

//Delete a Blog post category
export async function deleteCategory(id) {
  return await sendRequest(`${BASE_URL}/${id}`, 'DELETE');
}
